import React from 'react'
import {isEmpty} from 'lodash'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import EditService from './EditService'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'
import LinearLoader from '../UI/LinearLoader'
import ServiceNotFound from './ServiceNotFound'

import Resource from '../../stores/resource'
const ServiceStore = Resource('services')

class EditServicePage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      service: {},
      error: '',
      loading: true
    }
  }

  componentWillMount() {
    ServiceStore.find(this.props.match.params.id)
    .then((result) => this.setState({service: result.data, loading: false}))
    .catch((error) => {
      this.setState({
        service: {},
        error: errors.unpack(error),
        loading: false
      })
    })
  }

  _closeErrorDialog = () => this.setState({error: ''})

  render() {
    const {
      loading,
      service,
      error
    } = this.state

    if (loading) return <LinearLoader />
    if (isEmpty(service)) return <ServiceNotFound/>

    return (
      <section>
        <header>
          <PageTitle>
            Edit service
          </PageTitle>
        </header>

        <EditService service={service} />
        <br/>
        <BackButton/>

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}>
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </section>
    )
  }

}

export default EditServicePage



// WEBPACK FOOTER //
// ./src/components/Services/EditServicePage.jsx